<template>
  <div class="word-search-container">
    <div class="word-search-content">
      <!-- 左侧手写搜字部分 -->
      <div class="content-left">
        <handwrite-search
          @characterSelected="handleCharacterSelected"
        ></handwrite-search>
      </div>
      <!-- 右侧内容部分 -->
      <div class="content-right">
        <div class="right-top">
          <course-video
            :exampleInfo="exampleInfo"
            :wordVideoInfo="wordVideoInfo"
            @wordPopUp="wordPopUp"
          ></course-video>
        </div>
        <div class="right-bottom">
          <div class="bottom-left">
            <char-book
              :exampleInfo="exampleInfo"
              :wordVideoInfo="wordVideoInfo"
              @wordPopUp="wordPopUp"
            ></char-book>
          </div>
          <div class="bottom-right">
            <char-video
              :exampleInfo="exampleInfo"
              :wordVideoInfo="wordVideoInfo"
              @wordPopUp="wordPopUp"
            ></char-video>
          </div>
        </div>
      </div>
    </div>
    <bottom-bar right-bar="student"></bottom-bar>
    <word-pop-new ref="word-pop"></word-pop-new>
  </div>
</template>

<script>
import BottomBar from "../../components/BottomBar.vue";
import HandwriteSearch from "./components/HandwriteSearch.vue";
import CourseVideo from "./components/CourseVideo.vue";
import CharBook from "./components/CharBook.vue";
import CharVideo from "./components/CharVideo.vue";
import WordPopNew from "../../components/WordPopNew.vue";

export default {
  name: "WordSearch",
  components: {
    BottomBar,
    HandwriteSearch,
    CourseVideo,
    CharBook,
    CharVideo,
    WordPopNew,
  },
  data() {
    return {
      wordVideoInfo: null,
      exampleInfo: null,
    };
  },
  mounted() {
    this.handleCharacterSelected("晓");
  },
  destroyed() {},
  methods: {
    handleCharacterSelected(char) {
      if (char === "") {
        // this.wordVideoInfo = null;
        // this.exampleInfo = null;
        return;
      }
      // 调用OCR识别接口
      this.$http
        .get(
          "https://api.xiaobixiezi.com/user/public/searchCoursePracticeByWord",
          { params: { word: char } }
        )
        .then((response) => {
          if (response.data.length > 0) {
            const words = response.data[0].physicsSegmentList;
            const examples = response.data[0].exampleList;
            const word = words.find((item) => item.title === char);
            const example = examples.find((item) => item.title === char);
            this.wordVideoInfo = word;
            this.exampleInfo = example;
          }
        });
    },
    wordPopUp({ data, tab }) {
      this.$refs["word-pop"].show(data, tab);
    },
  },
};
</script>
<style scoped>
html {
  height: 100vh;
  width: 100vw;
  overflow: hidden;
}
.word-search-container {
  width: 100vw;
  height: 100vh;
  background: url("../../assets/class_bg.png") no-repeat;
  background-size: 100% 100%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.word-search-content {
  gap: 0.6rem;
  display: flex;
  padding-bottom: 4rem;
}

.content-left {
  width: 40.31rem;
  height: 40.54rem;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 1.85rem 1.85rem 1.85rem 1.85rem;
  border: 0.04rem solid rgba(255, 255, 255, 0.6);
  box-sizing: border-box;
}

.content-right {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  width: 34.69rem;
  height: 40.54rem;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 1.85rem 1.85rem 1.85rem 1.85rem;
  border: 0.04rem solid rgba(255, 255, 255, 0.6);
  box-sizing: border-box;
  padding: 0.6rem;
}

.right-top {
}

.right-bottom {
  display: flex;
  gap: 0.6rem;
}

.bottom-left,
.bottom-right {
  flex: 1;
}
</style>
